export type FormatLocalizedNumberProperties = {
  locale: Locale;
  numberFormatProperties?: Intl.NumberFormatOptions;
  value?: number | string;
};

export type Locale = 'en-US' | 'es-ES';

export const formatLocalizedNumber = ({
  locale,
  numberFormatProperties,
  value,
}: FormatLocalizedNumberProperties): string => {
  if ((typeof value === 'string' && value.trim() === '') || Number.isNaN(Number(value))) {
    return '';
  }

  return new Intl.NumberFormat(locale, { maximumFractionDigits: 2, ...numberFormatProperties }).format(Number(value));
};
